import { z } from 'zod';

export interface Codeword {
  emoji: string;
  word: string;
}

function codeword<const Emoji extends string, const Word extends string>(emoji: Emoji, word: Word) {
  return { [word]: { emoji, word } } as { [Key in Word]: { emoji: Emoji; word: Key } };
}

export const Codewords = {
  ...codeword('🎈', 'BALLOON'),
  ...codeword('⏰', 'CLOCK'),
  ...codeword('🍋', 'LEMON'),
  ...codeword('🌊', 'OCEAN'),
  ...codeword('🐼', 'PANDA'),
  ...codeword('🌈', 'RAINBOW'),
  ...codeword('🌳', 'TREE'),
  ...codeword('🦓', 'ZEBRA'),
} as const satisfies Record<string, Codeword>;

export type CodewordId = keyof typeof Codewords;
export const codewordIds = Object.freeze(Object.keys(Codewords)) as readonly CodewordId[];
export const codewordIdSchema = z.enum(codewordIds as [CodewordId, ...CodewordId[]]);

export function formatCodeword(id: CodewordId): string {
  const codeword = Codewords[id];
  return `${codeword.emoji} ${codeword.word}`;
}
